<template>
  <div class="tw-max-w-3xl tw-mt-1.5 md:tw-m-auto">
    <div>
      <div class="tw-grid tw-h-10 tw-grid-cols-12 tw-gap-0">
        <input
          class="tw-box-border tw-text-sm tw-inline-block tw-w-full tw-h-10 tw-col-start-1 tw-col-end-12 tw-px-4 tw-font-normal tw-leading-10 tw-text-gray-600 tw-placeholder-gray-500 tw-transition tw-bg-white tw-border focus:tw-outline-none"
          autocomplete="off"
          v-model="filters[0].value"
          placeholder="Search Injury Cases..."
          @keyup="noSearchInput"
        />
        <div
          class="tw-col-start-12 tw-col-end-12 tw-bg-black search tw-rounded-r"
          @click="searchData(filters[0].value)"
        ></div>
      </div>
    </div>
    <div class="tw-w-full tw-mt-6 tw-pt-3 tw-m-0 tw-bg-white">
      <div id="tableHeader" class="tw-grid tw-mb-3 tw-object-top customCols">
        <div class="tw-flex-1 tw-pl-4 tw-w-108px tw-text-xs tw-font-medium tw-text-black">
          First Name
        </div>
        <div class="tw-flex-1 tw-w-92px tw-text-xs tw-font-medium tw-text-black">Last Name</div>
        <div class="tw-flex-1 tw-w-92px tw-text-xs tw-font-medium tw-text-black">Injury</div>
        <div class="tw-flex-1 tw-w-51px tw-ml-0 tw-text-xs tw-font-medium tw-text-black tw-mx-auto">
          Status
        </div>
      </div>
      <hr class="tw-mb-4 tw-w-full" />
      <div id="tableBody" class="tw-overflow-y-scroll tw-mt-0" style="height: 344px">
        <div
          class="tw-grid customCols tw-pb-4"
          v-for="injuryRecord in injuryCases"
          :key="injuryRecord._id"
          @click="handleRowClick(injuryRecord)"
        >
          <div
            class="tw-text-xs tw-pl-4 tw-w-108px tw-mt-auto tw-font-normal tw-leading-3 tw-text-left tw-h-3 tw-my-auto"
            v-if="
              injuryRecord.member &&
              injuryRecord.member.profile &&
              injuryRecord.member.profile.firstName
            "
          >
            {{ injuryRecord.member.profile.firstName }}
          </div>
          <div v-else></div>
          <div
            class="tw-text-xs tw-w-92px tw-font-normal tw-mt-auto tw-leading-3 tw-text-left tw-my-auto"
            v-if="
              injuryRecord.member &&
              injuryRecord.member.profile &&
              injuryRecord.member.profile.lastName
            "
          >
            {{ injuryRecord.member.profile.lastName }}
          </div>
          <div v-else></div>

          <div
            class="tw-text-xs tw-w-92px tw-font-normal tw-mt-auto tw-leading-3 tw-text-left tw-my-auto"
            v-if="injuryRecord.natureOfInjury[0] && injuryRecord.natureOfInjury[0].injury"
          >
            {{ injuryRecord.natureOfInjury[0].injury }}
          </div>
          <div v-else></div>

          <div
            class="tw-text-8px tw-leading-6px tw-w-51px tw-pr-4 sm:tw-pr-0 tw-font-normal tw-text-green-700 tw-inline-grid tw-justify-items-start"
          >
            <div v-if="injuryRecord.status === 'Completed'" class="tw-mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-mx-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <div class="tw-mt-0.5">{{ injuryRecord.status }}</div>
            </div>
            <div v-else class="tw-text-amber-700 tw-mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4 tw-mx-auto"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                />
                <path
                  fill-rule="evenodd"
                  d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                  clip-rule="evenodd"
                />
              </svg>

              <div class="tw-mt-0.5">Draft</div>
            </div>
          </div>

          <hr class="tw-mt-2.5 tw-w-full" />
          <hr class="tw-mt-2.5 tw-w-full" />
          <hr class="tw-mt-2.5 tw-w-full" />
          <hr class="tw-mt-2.5 tw-w-full" />
        </div>
      </div>
      <hr class="tw-w-full" />
      <div
        id="More"
        v-if="injuryCases.length > 0 && this.pageNumber <= this.pages && this.pages > 1"
        class="tw-flex tw-justify-center tw-items-center tw-font-normal tw-object-bottom tw-py-2.5"
        style="height: 32px"
      >
        <button type="link" class="tw-text-xs tw-uppercase tw-pr-1" @click="loadMoreData">
          More
        </button>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="tw-h-3 tw-bg-no-repeat tw-bg-center tw-font-normal tw-pr-1 tw-pb-1"
          viewBox="0 0 15 15"
          fill="currentColor"
          @click="loadMoreData"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>

    <div class="tw-flex tw-justify-center">
      <button class="btn-success tw-mt-8" @click="add" type="success">Add New Injury Report</button>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { roles, compCasesTypes } from "@/utils/constants";

export default {
  data() {
    return {
      compCasesTypes,
      roles,
      tableData: [],
      pageSize: 20,
      filters: [
        {
          value: "",
          filterFn: (row, filter) =>
            Object.keys(row).some((prop) => {
              if (prop === "member") {
                const { firstName, lastName } = row[prop].profile;
                const { _id } = row[prop];
                const filterRegex = new RegExp(filter.value, "i");
                return (
                  _id.toString().match(filterRegex) ||
                  firstName.match(filterRegex) ||
                  lastName.match(filterRegex)
                );
              }
              return false;
            }),
        },
        {
          value: [],
        },
      ],
      tableProps: {
        border: true,
      },
      paginationProps: {
        pageSizes: [20, 50, 100],
      },
      injuryRecord: {},
      pages: 0,
      pageNumber: 1,
      injuryCases: [],
      filteredData: [], //Search is filled
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);
    this.$http
      .get("/nrl/api/v1/admin/competition-cases")
      .then((response) => {
        this.tableData = _.chain(response.data.data)
          .filter((x) => x.type === 2)
          .value();

        this.pages = Math.ceil(this.tableData.length / 20);

        this.injuryCases = this.tableData.slice(0, 20);
        this.$store.commit("root/loading", false);
      })
      .catch(() => {
        this.$store.commit("root/loading", false);
        this.$customError();
      });
  },
  methods: {
    add() {
      this.$router.push({ name: "injury-cases-add" });
    },
    noSearchInput() {
      this.pageNumber = 1;
      this.pages = Math.ceil(this.tableData.length / 20);
      this.injuryCases = this.tableData.slice(0, 20);
    },
    loadMoreData() {
      if (this.pageNumber > this.pages) return;
      this.pageNumber++;
      let records = this.pageNumber * 20;

      // Search field is filled :
      if (this.filters && this.filters[0].value) {
        this.injuryCases = this.filteredData.slice(0, records);
      } else {
        this.injuryCases = this.tableData.slice(0, records);
      }
    },
    searchData(searchWord) {
      if (searchWord === "") {
        this.injuryCases = this.tableData;
        return this.injuryCases.slice(0, 20);
      }
      this.injuryCases = this.tableData.filter(
        (record) =>
          record.member.profile.firstName === searchWord ||
          record.member.profile.lastName === searchWord
      );
      this.pageNumber = 1;
      this.filteredData = this.injuryCases;
      this.pages = Math.ceil(this.filteredData.length / 20);
      let records = this.pageNumber * 20;
      return this.filteredData.slice(0, records);
    },
    handleRowClick(row) {
      this.$router.push({
        name: "injury-cases.update",
        params: {
          type: "update",
          id: row._id,
        },
      });
    },
    dateFormatter(row) {
      return row.modifiedAt ? this.dayjs(row.modifiedAt).format("MMMM Do YYYY, h:mm:ss a") : "NA";
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-success {
  @apply tw-justify-center sm:tw-w-72 tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  hover:tw-bg-green-300 hover:tw-text-black;
}

.search-bar {
  margin-bottom: 1rem;
}

.data-table {
  width: 100%;
}
.el-pagination {
  margin-top: 1rem !important;
}
</style>
<style>
@media only screen and (max-width: 767px) {
  .el-pagination {
    white-space: normal;
  }
}

@media only screen and (min-width: 320px) and (max-width: 365px) {
  span.el-pagination__sizes,
  span.el-pagination__total {
    margin-top: 10px;
  }
}

.search {
  background-image: url("../../assets/search.svg"); /* Add custom search */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position-y: 10px;
  padding: 10px;
}

.customCols {
  grid-template-columns: 1fr 1fr 1fr 51px;
}
</style>
